import Swal from "sweetalert2";
import { useForm, ValidationError } from '@formspree/react';
import { useRef, useEffect } from "react";
const Hire = () => {
    useEffect(()=>{
        document.title ="Udoka | Hire me"
})
    const elemRef = useRef(null)
    const [state, handlestate] = useForm("mqkvvryv");
    
    const handleSubmit = () => {
        const hirer_name = document.querySelector('#hirer_name');
        const hirer_email = document.querySelector('#hirer_email');
        const hirer_tel = document.querySelector('#hirer_tel');
        const project = document.querySelector('#project');
        const description = document.querySelector('#description');
        
        if (hirer_name.value && hirer_email.value && hirer_tel.value && project.value && description.value !== null) {
            Swal.fire({
                icon: 'success',
                title: 'success',

                text: 'Request submited successfully! '
            });
           setTimeout( ()=>{
            elemRef.current.reset()
           },2000)
        }
        else if (hirer_name.value && hirer_email.value && hirer_tel.value && project.value && description.value === null) {
            Swal.fire({
                icon: 'info',

                text: 'empty field(s)!'
            });
        }
    }
    return (
        <div className="w-full py-4 bg-black/30 flex flex-col space-y-4 justify-center items-center px-2 mt-4">
            <div className="text-white font-bold text-center">Hire me today for your project. My work is always superb!</div>
            <form ref={elemRef} onSubmit={handlestate} className="w-[350px] py-4 px-2  rounded-lg shadow-lg shadow-white flex flex-col space-y-4 justify-between items-center" method="POST">
                <input required type="text" name="name" id="hirer_name" placeholder="Full Name" className="outline-none h-16 border-gray-500 border-2 rounded-lg bg-transparent py-1 px-2 text-center placeholder-gray-400 text-xl font-mono text-white w-full" />
                <input required type="tel" name="tel" id="hirer_tel" placeholder="Telephone" className="outline-none h-16 border-gray-500 border-2 rounded-lg bg-transparent py-1 px-2 text-center placeholder-gray-400 text-xl font-mono text-white w-full" />
                <input required type="email" name="email" id="hirer_email" placeholder="Email" className="outline-none h-16 border-gray-500 border-2 rounded-lg bg-transparent py-1 px-2 text-center placeholder-gray-400 text-xl font-mono text-white w-full" />
                <input required type="text" name="project-name" id="project" placeholder="Project Name" className="outline-none h-16 border-gray-500 border-2 rounded-lg bg-transparent py-1 px-2 text-center placeholder-gray-400 text-xl font-mono text-white w-full" />
                <textarea required name="description" id="description" placeholder="Project Description" className="outline-none  border-gray-500 border-2 rounded-lg bg-transparent py-2 px-2 text-center placeholder-gray-400 text-xl font-mono text-white w-full" ></textarea>
                <button onClick={handleSubmit} disabled={state.submitting} className="w-full py-4 px-2 text-center bg-yellow-500 text-white font-bold rounded-lg" type="submit">Submit</button>
            </form>
        </div>);
}

export default Hire;